import React__default from 'react';
import Input from 'reactstrap/lib/Input';
import Label from 'reactstrap/lib/Label';

const AppRadioBtn = ({ id, name, labelText, value, isChecked, onChange, style, className, labelClassName, inputClassName }) => {
    return (React__default.createElement("span", { style: Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", height: "22px", fontSize: "1rem", letterSpacing: "-0.01rem", cursor: "pointer" }, style), { marginLeft: `calc(${(style === null || style === void 0 ? void 0 : style.marginLeft) || "0px"} + 22px)` }), className: className },
        React__default.createElement(Label, { check /* for={name} */: true, style: { margin: 0, cursor: "pointer" }, className: labelClassName },
            React__default.createElement(Input, { id: id, type: "radio", name: name, value: value, checked: isChecked, onChange: onChange, style: {
                    height: "22px",
                    width: "22px",
                    margin: 0,
                    cursor: "pointer",
                    marginLeft: "calc(-22px - 9px)"
                }, className: inputClassName }),
            labelText)));
};

export { AppRadioBtn as default };
//# sourceMappingURL=AppRadioBtn.js.map
